import { forwardRef } from 'react'
import { TextField } from './input.styled'
import { useFormContext, useController } from 'react-hook-form'
import { string } from 'prop-types'
import { useRequiredRule } from '@bluheadless/ui-logic/src/hooks/form/useRequiredRule'
import { useThemeProps } from '@mui/system'

const Input = forwardRef(function Input({ inputProps, ...inProps }, ref) {
	const props = useThemeProps({
		name: 'BHInput',
		props: inProps,
	})

	const { label, value } = props

	return (
		<TextField
			ref={ref}
			inputProps={{
				'aria-label': label,
				...inputProps,
			}}
			filled={!!value}
			{...props}
		/>
	)
})

const ControlledInput = ({
	name: nameProp,
	onChange: onChangeProp,
	onBlur: onBlurProp,
	helperText,
	defaultValue,
	rules,
	disabled: _disabled,
	...props
}) => {
	const formContext = useFormContext()
	const isSubmitting = formContext?.formState?.isSubmitting

	const disabled = _disabled ?? isSubmitting

	const required = useRequiredRule({ rule: props.required, label: props.label, name: nameProp })

	const {
		field: { onChange, onBlur, name, value, ref },
		fieldState: { error },
	} = useController({
		name: nameProp,
		defaultValue,
		rules: {
			required,
			...rules,
		},
	})

	return (
		<Input
			onChange={(...args) => {
				onChange(...args)
				if (onChangeProp) onChangeProp(...args)
			}}
			onBlur={(...args) => {
				onBlur(...args)
				if (onBlurProp) onBlurProp(...args)
			}}
			value={value}
			name={name}
			inputRef={ref}
			error={!!error}
			helperText={error?.message || helperText}
			disabled={disabled}
			{...props}
		/>
	)
}

Input.defaultProps = {
	...TextField.defaultProps,
}

Input.propTypes = {
	...TextField.propTypes,
}

ControlledInput.defaultProps = {
	...Input.defaultProps,
	defaultValue: '',
	helperText: ' ',
}

ControlledInput.propTypes = {
	...Input.propTypes,
	name: string.isRequired,
}

export default Input
export { Input, ControlledInput }
